import { defineStore } from 'pinia';
import { ref } from 'vue';
import Client from '@/repositories/clients/AuthenticatedClient';
import PurchaseRepository from '@/repositories/PurchaseRepository';
import { useTokenBalanceStore } from '@/stores/useTokenBalanceStore';

export const useBenchmarkPurchaseStore = defineStore('benchmarkPurchase', () => {
  const purchase = ref(null);
  let settle = null;
  let queue = Promise.resolve();

  async function open(toolId, payload) {
    if (settle) throw new Error('A benchmark confirmation is already open.');
    const { data: quote } = await Client.post('/tools/benchmark-quote', { tool_id: toolId, request: payload });
    const { data } = await PurchaseRepository.quote({
      kind: 'benchmark', ...quote, scope: { tool_id: toolId, request: payload },
    });
    await useTokenBalanceStore().refresh({ force: true });
    purchase.value = { ...data, scenario_count: quote.scenario_count, scenario_days: quote.scenario_days, days_per_scenario: quote.days_per_scenario };
    return new Promise(resolve => { settle = resolve; });
  }

  function confirm(toolId, payload) {
    const result = queue.then(() => open(toolId, payload));
    queue = result.catch(() => {});
    return result;
  }

  function choose(useTokens) {
    const resolve = settle;
    settle = null;
    const version = purchase.value?.rate_version;
    purchase.value = null;
    resolve?.(useTokens ? { rateVersion: version } : false);
  }

  return { purchase, confirm, choose };
});
